// Obecność sztuki z widoku bramy (core.ViewPresence): worker liczy status, APP tylko wyświetla (PROJEKT.md 8).
// Online / Offline pokazuje znacznik stanu karty (StanPolaczenia), tu tylko dopisek: przez tablet „X”, lokalnie przez
// tablet, od kiedy offline. Czas „od” jako godzina albo data - napis się nie starzeje i nie trzeba go przeliczać co minutę.
import type { StatusObecnosci, ViewDoc } from "../../gen/kontrakt";
import { t } from "../../i18n/t";
import { godzinaLubData } from "../../uklad/format";

export interface Obecnosc {
  /** Dopisek przy znaczniku Online/Offline ("" = bez dopisku) */
  tekst: string;
  tytul: string;
}

/** Online i most przez tablet liczą się jako „Online” (liczniki, filtr) - jak w starej APP. */
export function jestOnline(s: StatusObecnosci | undefined): boolean {
  return s === "online" || s === "bridge";
}

export function obecnosc(widok: ViewDoc | null, nazwaTabletu: string | undefined, teraz = new Date()): Obecnosc {
  const p = widok?.presence;
  const tablet = nazwaTabletu || p?.via || "";
  switch (p?.status) {
    case "online":
      return { tekst: "", tytul: "" };
    case "bridge":
      return { tekst: t("przez tablet „{tablet}”", { tablet }), tytul: t("Dane i sterowanie przez tablet") };
    case "local":
      return { tekst: t("lokalnie przez tablet „{tablet}”", { tablet }), tytul: t("W zasięgu tabletu „{tablet}”", { tablet }) };
  }
  const od = p?.since ?? p?.last_live;
  return { tekst: od ? t("od {czas}", { czas: godzinaLubData(od, teraz) }) : "", tytul: "" };
}
